import { useCallback, useEffect, useRef } from 'react';
import debounce from 'lodash/debounce';
/** A hook for creating a debounced callback function */
const useDebouncedCallback = function (/** any function you want to debounce */
cb,
/** dependencies your callback relies on.
 * Callback will be reevaluated when dependencies change -
 * (same as React's useCallback hook) */
dependencies, /** debounce timeout in milliseconds (default: 200) */
debounceMs) {
  if (debounceMs === void 0) {
    debounceMs = 200;
  }
  const callbackRef = useRef(cb);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedCallback = useCallback(debounce(function () {
    callbackRef.current(...arguments);
  }, debounceMs), [debounceMs]);
  // update callback function when its dependencies change
  useEffect(() => {
    callbackRef.current = cb;
  }, [cb, dependencies]);
  return debouncedCallback;
};
export default useDebouncedCallback;
//# sourceMappingURL=use-debounced-callback.js.map